export const CDN_BASE_URL =
    process.env.REACT_APP_CDN_PATH || "https://images.collectdiv.com";
const base_cdn_url = CDN_BASE_URL;

export const DEFAULT_IMAGE_URL = "/DEFAULT.PNG";

const failedImageUrls = new Set();
const preloadedImageUrls = new Set();

function normalizeImageUrl(url) {
    if (!url) return "";
    if (typeof window === "undefined") return String(url);
    try {
        return new URL(url, window.location.origin).href;
    } catch {
        return String(url);
    }
}

export function hasImageFailed(url) {
    return failedImageUrls.has(normalizeImageUrl(url));
}

export function markImageFailed(url) {
    const normalized = normalizeImageUrl(url);
    if (!normalized || normalized === normalizeImageUrl(DEFAULT_IMAGE_URL)) {
        return;
    }
    failedImageUrls.add(normalized);
}

export function resolveImageUrl(url) {
    console.log(url);
    if (!url || hasImageFailed(url)) {
        return DEFAULT_IMAGE_URL;
    }
    return url;
}

export function handleImageError(event) {
    const img = event.currentTarget || event.target;
    if (!img) return;
    img.onerror = null;
    markImageFailed(img.getAttribute("src"));
    markImageFailed(img.src);
    if (img.getAttribute("src") !== DEFAULT_IMAGE_URL) {
        img.src = DEFAULT_IMAGE_URL;
    }
}

export function nameFormat(database_name) {
    console.log(database_name);
    if (!database_name) {
        return database_name;
    }
    return database_name.replace("/", "_");
}

function resolveCardResolution(resolution = true) {
    if (resolution === "thumb" || resolution === "thumbnail") return "thumb";
    if (resolution === "low" || resolution === false) return "low";
    return "high";
}

// resolution: true|"high" | false|"low" | "thumb"
export function getImageUrl(product, resolution = true) {
    if (!product) {
        return "";
    }

    if (product.type === "CARD") {
        const size = resolveCardResolution(resolution);
        return resolveImageUrl(`${base_cdn_url}/imgs/${product.setId}-${size}.png`);
    }

    return resolveImageUrl(`${base_cdn_url}/products/${product.name}.PNG`);
}

export function getDefaultImageUrl() {
    return DEFAULT_IMAGE_URL;
}

export function preloadImageUrl(url) {
    if (!url || hasImageFailed(url) || preloadedImageUrls.has(url)) {
        return;
    }
    preloadedImageUrls.add(url);
    const img = new Image();
    img.decoding = "async";
    img.onerror = () => {
        markImageFailed(url);
        markImageFailed(img.src);
    };
    img.src = url;
}

export function preloadProductImage(product, resolution = true) {
    preloadImageUrl(getImageUrl(product, resolution));
}

export function preloadAdjacentProductImages(
    products,
    currentProductId,
    radius = 1,
    highRes = true
) {
    if (!Array.isArray(products) || !products.length || currentProductId == null) {
        return;
    }

    const currentIndex = products.findIndex((product) => product.id === currentProductId);
    if (currentIndex === -1) {
        return;
    }

    for (let step = -radius; step <= radius; step += 1) {
        if (step === 0) {
            continue;
        }
        const nextIndex = (currentIndex + step + products.length) % products.length;
        preloadProductImage(products[nextIndex], highRes);
    }
}
